<template>
    
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header card-header-info">
                            <div class="row">
                            <div class="col-md-6">
                                <h4 class="card-title ">Daftar Mikrotik</h4>
                                <p class="card-category">Berikut daftar Mikrotik anda</p>
                            </div>
                            <div class="col-md-6" v-show="false">
                                <h2 class="card-title text-right">{{data.filtered}}</h2>
                            </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead class=" text-info">
                                        <th width="40px">No.</th>
                                        <th>Nama</th>
                                        <th>Login</th>
                                        <th>Via</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(u, index) in theGet.data.List">
                                            <td>{{ index+1 }}</td>
                                            <td>{{ u.nama }}</td>
                                            <td>{{ u.ip }}</td>
                                            <td style="text-transform: uppercase;">{{ u.via }}</td>
                                        </tr>
                                        <tr v-if="theGet.data.List == null">
                                            <td></td>
                                            <td>Tidak ada Data </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="text-center">
                                    <button v-show="data.btnAmbilMikrotik" class="btn btn-success" @click="data.btnAmbilMikrotik = false, data.loadingMikrotik = true, mikrotik.start()">Ambil Data Mikrotik</button>
                                    <span v-show="data.loadingMikrotik" class="text-info">Sedang mengambil data Mikrotik...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="notif">
                        <div class="alert alert-info" v-for="(u, index) in data.alerte">
                            {{u.teks}}
                        </div>
                    </div>
                    
                    <div class="card">
                        <div class="card-body">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead class=" text-info">
                                        <th width="40px">No.</th>
                                        <th>Pelanggan</th>
                                        <th>Area</th>
                                        <th>PPOE</th>
                                        <th>Mikrotik</th>
                                        <th>Apakah Singkron ?</th>
                                        <th>Aksi</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(u, index) in data.pelangganCheck">
                                            <td>{{ index+1 }}</td>
                                            <td>{{ u.nama }} </br> {{ u.wa }}</td>
                                            <td>{{ u.area }}</td>
                                            <td class="text-info">{{ u.ppoe }}</td>
                                            <td>{{ u.mikrotik }}</td>
                                            <td>
                                                <span class="text-success" v-if="u.singkron == 'Singkron'">Singkrong</span>
                                                <span class="text-warning" v-else>Tidak</span>
                                            </td>
                                            <td>
                                                <button v-if="u.singkron != 'Singkron'" class="btn btn-info" @click="data.sxIndex = index,data.sxUid = u.uid,data.sxNama = u.nama,data.modalSingkron = true, data.sxPPOE = '', data.sxMikrotik = ''">Singkronkan</button>
                                            </td>
                                        </tr>
                                        <tr v-if="theGet.data.List == null">
                                            <td></td>
                                            <td>Tidak ada Data </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>

            <!-- MODAL -->
            <div class="modal" tabindex="-1" role="dialog" v-show="data.modalSingkron">
                <div class="overlay"></div>
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Pilih Mikrotik</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalSingkron = false">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <div class="form-group">
                                            <label class="bmd-label-floating">Pelanggan</label>
                                            <input type="text" class="form-control" v-model="data.sxNama" disabled>  
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="form-group">
                                            <label class="bmd-label-floating">PPOE</label>
                                            <input type="text" class="form-control" v-model="data.sxPPOE">  
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="form-group">
                                            <label class="bmd-label-floating">Mikrotik</label>
                                            <select class="form-control" id="exampleFormControlSelect1" placeholder="Pilih Resto..."  v-model="data.sxMikrotik">
                                                <option value="" selected disabled>Pilih Mikrotik</option>
                                                <option v-for="(u, index) in theGet.data.List" :value="u.id" @click="data.sxMikrotikNama = u.nama">{{u.nama}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <p class="text-info" v-show="mikrotik.data.isPPOEada">{{mikrotik.data.isTeks}}</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" @click="data.modalSingkron = false">Batal</button>
                            <button type="button" class="btn btn-info" @click="mikrotik.simpan()">Simpan</button>

                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'

import { url,homePage } from '@/var/var.js'
import VueBarcode from 'vue-barcode';

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

Vue.use(moment)

export default {
  name: 'Beranda',
  components: { 

  }, 
  setup() {
    const data = reactive({
      pelanggan: [],
      pelangganCheck: [],

      json: [],
      alerte: [],

      btnAmbilMikrotik: true,
      loadingMikrotik: false,
      modalSingkron: false,

      //SINGKRONASI
      sxIndex: '',
      sxUid: '',
      sxNama: '',
      sxPPOE: '',
      sxMikrotik: '', // mikrotik id
      sxMikrotikNama: ''

      /* modal edit tarif */
    })

    const theGet = {
        data: reactive({
            List: [],
        }),
        datae() {
            var datax = {
                token: 'TangTung '+sessionStorage.getItem('myToken')
            }
                
            var apiUrl = inter.MiktorikList();

            myGlobal.call(datax,apiUrl).then(x => {

                //console.log(JSON.stringify(x));

                if (x.status == true) {
                    
                    this.data.List = x.data;

                    // console.log(this.data.List.length);

                } else {
                    //alert(x.pesan);
                }
            })
        },
        Pelanggan() {

            this.isCari = false;

            var datax = new FormData();
            datax.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
            datax.append('type', "all");
            datax.append('bulan', "0");
            datax.append('page', "all");
            datax.append('tahun', myGlobal.getTahunNow());

            //alert(this.$route.params.filter);
            
            var apiUrl = inter.PelangganList();
            myGlobal.call(datax,apiUrl).then(x => {       
                //console.log(JSON.stringify(x));

                if (x.status) {
                    data.pelanggan = x.data;

                } else {
                 //alert(x.pesan);
                }
            })

        },
    }

    const mikrotik = {
        data: reactive({
            progress: 0,
            isPPOEada: false,
            isTeks: ''
        }),
        simpan() {
            if (data.sxPPOE == '') {
                this.data.isPPOEada = true;
                this.data.isTeks = "PPOE Tidak boleh kosong";
                return false;
            }
            if (data.sxMikrotik == '') {
                this.data.isPPOEada = true;
                this.data.isTeks = "Mikrotik Tidak boleh kosong"
                return false;
            }

            var result = data.json.filter( obj => obj.id === data.sxMikrotik)[0];

            if (result) {
                if (result.id == data.sxMikrotik) {
                        
                    var d = result.data;

                    var test = JSON.stringify(d); // json data mikrotiknya

                    //console.log(test);
                    //console.log(nama);

                    if(test.indexOf('"'+data.sxPPOE+'"') >= 0){
                        // lanjot
                    } else {
                        this.data.isPPOEada = true;
                        this.data.isTeks = "Kok PPOE di mikrotik ini ga ketemu?";
                        return false;
                    }
                }
                
            }

            this.data.isPPOEada = false;
            data.modalSingkron = false;

            var datax = {
                token: 'TangTung '+sessionStorage.getItem('myToken'),
                id: data.sxUid,
                mikrotik: data.sxMikrotik,
                ppoe: data.sxPPOE
            }
                
            var apiUrl = inter.PelangganUpdateMikrotik();

            myGlobal.call(datax,apiUrl).then(x => {
                //console.log(JSON.stringify(x));

                if (x.status == true) {

                    data.pelangganCheck[data.sxIndex].singkron = "Singkron";
                    data.pelangganCheck[data.sxIndex].ppoe = data.sxPPOE;
                    data.pelangganCheck[data.sxIndex].mikrotik = data.sxMikrotikNama;

                } else {
                    //alert(x.pesan);
                }
            })
        },
        start() {
            var mi = theGet.data.List;
            if (mi.length > 0) {
                if (this.data.progress < mi.length) {
                    var item = mi[this.data.progress];

                    mikrotik.getBlogCount(item.via,item.ip,item.username,item.password,item.id,item.nama);
                } else {
                    data.loadingMikrotik = false;
                    mikrotik.startSingkron();
                }
            }
        },
        getBlogCount(via,ip,username,password,id,nama) {
            var datax = {
                ip: ip,
                username:username,
                password:password,
                via:via
            }
                
            var apiUrl = "list-pelanggan.php";

            myGlobal.callMikrotik(datax,apiUrl).then(x => {
                var dataxx = x.data;

                var sing = {
                    id: id,
                    nama: nama,
                    data: dataxx
                }

                data.json.push(sing);

                // console.log(JSON.stringify(data.json));
                

                var alertx = {
                    teks: "Berhasil mendapatkan data Mikrotik "+nama
                }

                data.alerte.push(alertx);

                this.data.progress++;

                this.start();

            })

        },
        startSingkron() {
          var i;
          for (i = 0; i < data.pelanggan.length; i++) {
            var pel = data.pelanggan[i];

            var getSi = mikrotik.cekSingkron(pel.user.mikrotik_id,pel.user.ppoe);

            var x = {
                uid: pel.user.uid,
                nama: pel.user.unama,
                wa: pel.user.wa,
                area: pel.area,
                ppoe: pel.user.ppoe,
                mikrotik: getSi.nama,
                singkron: getSi.singkron
            }

            data.pelangganCheck.push(x);
          }
        },
        cekSingkron(idmikrotik,nama) { // id mikrotik, ppoe
            //var i;
            //for (i = 0; i < data.json.length; i++) {
                var result = data.json.filter( obj => obj.id === idmikrotik)[0];
                if (result) {
                    //console.log(result);

                    if (result.id == idmikrotik) {
                        
                        var d = result.data;

                        var test = JSON.stringify(d); // json data mikrotiknya
                        var namaMikrotik = result.nama;

                        //console.log(test);
                        //console.log(nama);

                        if(test.indexOf('"'+nama+'"') >= 0){
                            var dd = {
                                nama: namaMikrotik,
                                singkron: "Singkron"
                            }
                            return dd;
                        } else {
                            var dd = {
                                nama: namaMikrotik,
                                singkron: "Tidak"
                            }
                            return dd;
                        }
                    }
                } else {
                    var dd = {
                        nama: "-",
                        singkron: "Tidak"
                    }
                    return dd;
                }
            //}

        }
    }

    return {
      data, 
      mikrotik,
      theGet
    }
  },
  mounted () {
    document.title = "Singkron Pelanggan";

    this.theGet.datae();
    this.theGet.Pelanggan();
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/pelanggan/singkron.vue